module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAS1BMVEUAAABVYndVYnhRYHFVYndVYndVYndVYndVYXdVYndVYndWYndVZHhTYndVYXZVYndRY3RVY3hVYHVVVWpVYXZWY3ZUYXVQYHBVYndj11ZeAAAAGHRSTlMAn2Ag6fXf2cHLq497bVQ8LCQYDIRQTBBNb5p6AAAAvUlEQVRIx+3UyQ6DMAxFUQZDwhDm4f3/l5ZWqKJYsWEFqjjb6G6iJwfXi4iis02JRXmuKfBRnGlyrPLDSW/xZftjTZdhI+uONK3BD9PqTUPYoUZr6gRMUstN9W54VUmNg4eTZuBV+mcgKHwzEOWeGchs75mBKOv4DHSm5TPQUcNmwEjjqNSGj2My6YKgonRhpu0hgWo9NE90i8iGO1aP+FN0q8jFO+5WX/5H0QjVyKKZoKA5YOIhFA1x8LjMC95Naz8/ucb+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/home-3-fill@2x.png
// module id = k1n3
// module chunks = 44